/* eslint-disable consistent-return */
import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { OilReportResponse } from '../../utils/types';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40%',
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: '6px 24px 24px 24px',
  '@media (max-width: 1400px)': {
    width: '70%',
  },
  '@media (max-width: 768px)': {
    width: '90%',
    height: 'auto',
    p: 2,
  },
};

interface ModalProps {
  show: boolean;
  setOpenFrom: () => void;
  onConfirm: () => void;
  data: OilReportResponse;
}

export default function DuplicacyConfirmationModal({
  show, setOpenFrom, onConfirm, data,
}: ModalProps): JSX.Element {
  return (
    <Modal
      open={show}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="duplicacyConfirmationModal flex-row">
          <div className="header">
            Confirmation
          </div>
          <div onClick={setOpenFrom}>
            <CloseIcon />
          </div>
        </div>
        <div className="duplicacyConfirmationModalBody">
          <p>
            {data?.IsAllKitIdAlreadyExist
              ? 'All Oil Reports from this file already exist in the system. Are you sure you want to proceed importing?'
              : 'Below Oil Reports already exist in the system. Are you sure you want to proceed importing?'}
          </p>
          {!data?.IsAllKitIdAlreadyExist && (
            <p className="boldData">
              <span>Kit# : </span>
              {data?.KitIds?.join(', ')}
            </p>
          )}
          <div className="save_and_next_div mt-4">
            <div>
              <Button className="button_cancel" onClick={setOpenFrom}>Abort</Button>
            </div>
            <div className="button_margin_left">
              <Button className="button_save_and_next" onClick={onConfirm}>Proceed</Button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
